import { PropsWithChildren, forwardRef } from 'react';

import { notificationBarClass } from './NotificationBar.css';
import { InnerNotificationBox, NotificationProps } from './NotificationBox';
import { notificationBoxBaseClass, notificationBoxVariantClass } from './NotificationBox.css';
import { getClassNames } from '../../util/css';
import { PageGrid } from '../PageGrid/PageGrid';

type NotificationBarProps = Omit<NotificationProps, 'emphasis' | 'isElevated' | 'isAlert'>;

const sparkyClassName = 'notification-bar-sparky';

export const NotificationBar = forwardRef<HTMLDivElement, PropsWithChildren<NotificationBarProps>>(
  ({ variant = 'info', title, text }, ref) => {
    return (
      <div
        ref={ref}
        className={getClassNames(
          sparkyClassName,
          notificationBoxBaseClass,
          notificationBoxVariantClass[variant],
          notificationBarClass,
        )}
        role="alert">
        <PageGrid>
          <PageGrid.Item gridColumn="1/-1">
            <InnerNotificationBox variant={variant} title={title} text={text} headingLevel="h2" />
          </PageGrid.Item>
        </PageGrid>
      </div>
    );
  },
);

NotificationBar.toString = () => `.${sparkyClassName}`;

NotificationBar.displayName = 'NotificationBar';
